import React, { lazy, Suspense } from 'react'
import { useSelector } from 'hooks'
import { Redirect } from 'components'

// import Mailbox from './Mailbox';

const LazyMailbox = lazy(() => import(/* webpackChunkName: "mailbox" */ './Mailbox'))

const Mailbox = props => {
  if (!useSelector(s => s.flags.mailbox)) {
    return <Redirect to="/" />
  }
  return (
    <Suspense fallback={null}>
      <LazyMailbox {...props} />
    </Suspense>
  )
}

export default Mailbox
